import { } from 'react-redux';

import { Action } from '@reduxjs/toolkit';

import { BpAnswers } from '@boldpenguin/agent-quote-start';

import * as actionTypes from '../constants/actionTypes';
import { updateObject } from '../../../../shared/utils';
import { AppAction } from '../../../../store';

export interface BoldPenguinQuotationState {
  quoteApplicationData: BpAnswers | null,
  error: null,
  quoteApplicationDataLoading: boolean,
  saveBoldPenguinApplicationId: boolean
};

const initialState: BoldPenguinQuotationState = {
  quoteApplicationData: null,
  error: null,
  quoteApplicationDataLoading: false,
  saveBoldPenguinApplicationId: false,
};

const getQuoteApplicationDataStart = (state: BoldPenguinQuotationState, action: AppAction<BpAnswers | null>) => {
  return updateObject(state, {
    error: null,
    quoteApplicationDataLoading: true,
  });
};

const getQuoteApplicationDataSuccess = (state: BoldPenguinQuotationState, action: AppAction<BpAnswers | null>) => {
  return updateObject(state, {
    quoteApplicationData: action.data,
    error: null,
    quoteApplicationDataLoading: false,
  });
};

const getQuoteApplicationDataFail = (state: BoldPenguinQuotationState, action: AppAction<BpAnswers | null>) => {
  return updateObject(state, {
    quoteApplicationData: null,
    error: action.error,
    quoteApplicationDataLoading: false,
  });
};

const saveBoldPenguinApplicationIdStart = (state: BoldPenguinQuotationState, action: AppAction<boolean | null>) => {
  return updateObject(state, {
    error: null,
    saveBoldPenguinApplicationIdLoading: true,
  });
};

const saveBoldPenguinApplicationIdSuccess = (state: BoldPenguinQuotationState, action: AppAction<boolean | null>) => {
  return updateObject(state, {
    error: null,
    saveBoldPenguinApplicationIdLoading: false,
  });
};

const saveBoldPenguinApplicationIdFail = (state: BoldPenguinQuotationState, action: AppAction<boolean | null>) => {
  return updateObject(state, {
    error: action.error,
    saveBoldPenguinApplicationIdLoading: false,
  });
};

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case actionTypes.GET_QUOTE_APPLICATION_DATA_START:
      return getQuoteApplicationDataStart(state, action as AppAction<BpAnswers | null>);
    case actionTypes.GET_QUOTE_APPLICATION_DATA_SUCCESS:
      return getQuoteApplicationDataSuccess(state, action as AppAction<BpAnswers | null>);
    case actionTypes.GET_QUOTE_APPLICATION_DATA_FAIL:
      return getQuoteApplicationDataFail(state, action as AppAction<BpAnswers | null>);

    case actionTypes.SAVE_BOLD_PENGUIN_APPLICATION_ID_START:
      return saveBoldPenguinApplicationIdStart(state, action as AppAction<boolean | null>);
    case actionTypes.SAVE_BOLD_PENGUIN_APPLICATION_ID_SUCCESS:
      return saveBoldPenguinApplicationIdSuccess(state, action as AppAction<boolean | null>);
    case actionTypes.SAVE_BOLD_PENGUIN_APPLICATION_ID_FAIL:
      return saveBoldPenguinApplicationIdFail(state, action as AppAction<boolean | null>);

    default:
      return state;
  }
};

export default reducer;
